import React from 'react';
import { Container, Row, Col, Accordion } from 'react-bootstrap';
import './pages.css';
import { FaBalanceScale, FaUtensils, FaShoppingBag, FaQuestionCircle } from 'react-icons/fa';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTruck } from '@fortawesome/free-solid-svg-icons';

const TermsOfService = () => {
  return (
    <Container className="terms-page py-5">
      <Row className="justify-content-center">
        <Col lg={10} xl={8}>
          <div className="text-center mb-5">
            <h1 className="display-4 mb-3 text-danger">
              <FaBalanceScale className="me-2" />
              Terms of Service
            </h1>
            <p className="lead">Effective Date: {new Date().toLocaleDateString()}</p>
            <p className="text-muted">By using Noureesh Foods, you agree to these terms</p>
          </div>

          <div className="intro-card p-4 p-md-5 mb-5 bg-light rounded">
            <h2 className="h4 mb-3 text-danger">Welcome to Noureesh Foods!</h2>
            <p>
              These Terms of Service outline the rules and regulations for using our website and services. 
              Please read them carefully before placing an order.
            </p>
          </div>

          <Accordion defaultActiveKey="0" flush className="mb-5 terms-accordion">
            <Accordion.Item eventKey="0" className="mb-3">
              <Accordion.Header>
                <FaUtensils className="me-2 text-danger" />
                <span className="h5 mb-0">1. Ordering Process</span>
              </Accordion.Header>
              <Accordion.Body>
                <ul className="terms-list">
                  <li>All orders are subject to product availability</li>
                  <li>We reserve the right to refuse service to anyone</li>
                  <li>You must provide accurate delivery information</li>
                  <li>Custom orders require advance notice (minimum 48 hours)</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1" className="mb-3">
              <Accordion.Header>
                <FaShoppingBag className="me-2 text-danger" />
                <span className="h5 mb-0">2. Pricing & Payments</span>
              </Accordion.Header>
              <Accordion.Body>
                <ul className="terms-list">
                  <li>All prices are in Naira (₦) and inclusive of VAT where applicable</li>
                  <li>We accept various payment methods shown at checkout</li>
                  <li>Payment must be completed before order processing</li>
                  <li>Prices may change without notice (existing orders honored)</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2" className="mb-3">
              <Accordion.Header>
                <FontAwesomeIcon icon= {faTruck} className="me-2 text-danger" />
                <span className="h5 mb-0">3. Delivery Policy</span>
              </Accordion.Header>
              <Accordion.Body>
                <div className="delivery-terms">
                  <div className="delivery-term-card">
                    <h4 className="h6 text-danger">Delivery Areas</h4>
                    <p>Currently serving Lagos mainland with plans to expand</p>
                  </div>
                  <div className="delivery-term-card">
                    <h4 className="h6 text-danger">Timeframes</h4>
                    <p>2-4 hours for standard orders (subject to traffic)</p>
                  </div>
                  <div className="delivery-term-card">
                    <h4 className="h6 text-danger">Fees</h4>
                    <p>₦1500-₦3000 depending on location (calculated at checkout)</p>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="3">
              <Accordion.Header>
                <FaQuestionCircle className="me-2 text-danger" />
                <span className="h5 mb-0">4. Cancellations & Refunds</span>
              </Accordion.Header>
              <Accordion.Body>
                <div className="refund-policy">
                  <div className="refund-tier">
                    <h4 className="h6 text-danger">Before Preparation</h4>
                    <p>Full refund available</p>
                  </div>
                  <div className="refund-tier">
                    <h4 className="h6 text-danger">During Preparation</h4>
                    <p>50% refund or store credit</p>
                  </div>
                  <div className="refund-tier">
                    <h4 className="h6 text-danger">After Dispatch</h4>
                    <p>No refund (except for damaged items)</p>
                  </div>
                </div>
                <p className="mt-3 small text-muted">
                  Refunds processed within 5-7 business days to original payment method
                </p>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>

          <div className="disclaimer-box p-4 border border-danger rounded mb-5">
            <h3 className="h5 text-danger">Important Disclaimer</h3>
            <p className="mb-0">
              While we take utmost care with food allergies, Noureesh Foods cannot guarantee completely allergen-free environments. 
              Customers with severe allergies should contact us before ordering.
            </p>
          </div>

          <div className="updates-box bg-light p-4 rounded">
            <h3 className="h5 text-danger">Changes to Terms</h3>
            <p>
              We may update these terms periodically. Continued use of our services after changes constitutes acceptance. 
              Significant changes will be notified via email or website notice.
            </p>
          </div>

          <div className="contact-box mt-5 p-4 text-center border-top border-danger">
            <h3 className="h5 text-danger">Need Clarification?</h3>
            <p className="mb-2">Contact our customer support:</p>
            <p className="mb-1">
              <a href="mailto:support@noureeshfoods.com" className="text-danger">support@noureeshfoods.com</a>
            </p>
            <p>+234 812 345 6789</p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default TermsOfService;